var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type === 'textarea' ? _c('textarea', _vm._b({
    ref: "input",
    attrs: {
      "rows": "4"
    },
    on: {
      "input": _vm.onInput
    }
  }, 'textarea', _vm.$props, false)) : _c('input', _vm._b({
    ref: "input",
    on: {
      "input": _vm.onInput
    }
  }, 'input', _vm.$props, false));
}
var staticRenderFns = []

export { render, staticRenderFns }